import { RegionalOption } from 'owa-regional-option';
var accountSubCategory = {
    key: 'timeAndLanguage',
    titleStringKey: 'optionSubcategory_account',
    options: [RegionalOption],
};
export default accountSubCategory;
//# sourceMappingURL=accountSubCategory.js.map